import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { UIModule } from "./ui/ui.module";
import { DataService } from "./data.service";
import { LoadingComponent } from "./helper/loading/loading.component";
import { SafePipe } from "./safe-pipe";

@NgModule({
  declarations: [LoadingComponent, SafePipe],
  imports: [CommonModule, UIModule],
  providers: [DataService],
  exports: [LoadingComponent, SafePipe],
})
export class SharedModule {}
